export default "__VITE_ASSET__1lTLMBSV__"